import { DEFAULT_WALLET_THEME } from "./defaultWalletTheme";
import {
  ResolvedPaletteColorTokens,
  ResolvedWalletTheme,
} from "./walletTheme.types";

const mergePaletteColor = (
  base: ResolvedPaletteColorTokens,
  override?: Partial<ResolvedPaletteColorTokens>
): ResolvedPaletteColorTokens => ({
  ...base,
  ...(override ?? {}),
});

export const normalizeWalletTheme = (
  theme?: Partial<ResolvedWalletTheme> | null
): ResolvedWalletTheme => {
  if (!theme) {
    return DEFAULT_WALLET_THEME;
  }

  return {
    primary: mergePaletteColor(DEFAULT_WALLET_THEME.primary, theme.primary),
    secondary: mergePaletteColor(
      DEFAULT_WALLET_THEME.secondary,
      theme.secondary
    ),
    info: mergePaletteColor(DEFAULT_WALLET_THEME.info, theme.info),
    success: mergePaletteColor(DEFAULT_WALLET_THEME.success, theme.success),
    warning: mergePaletteColor(DEFAULT_WALLET_THEME.warning, theme.warning),
    error: mergePaletteColor(DEFAULT_WALLET_THEME.error, theme.error),
    grey: { ...DEFAULT_WALLET_THEME.grey, ...(theme.grey ?? {}) },
    text: { ...DEFAULT_WALLET_THEME.text, ...(theme.text ?? {}) },
    background: {
      ...DEFAULT_WALLET_THEME.background,
      ...(theme.background ?? {}),
    },
    authPageColor: theme.authPageColor ?? DEFAULT_WALLET_THEME.authPageColor,
    countdownTimer: {
      ...DEFAULT_WALLET_THEME.countdownTimer,
      ...(theme.countdownTimer ?? {}),
    },
  };
};
